import { use } from 'react'
import { SelectedFilesContext } from '../contexts/SelectedFilesContext'

export function useSelectedContext() {
  const context = use(SelectedFilesContext)
  if (!context) {
    throw new Error('useSelectedContext must be used within SelectedFilesContextProvider')
  }
  return context
}
